export default __webpack_public_path__ + "static/media/heating.fb6396a9.jpg";